import {inject, Injectable} from '@angular/core';
import {filter, map, Observable, switchMap, combineLatest, take} from 'rxjs';
import {Account} from '../../domain/model/account.model';
import {AccountCreatorService} from '../services/account-creator.service';
import {AccountStoreService} from '../services/account-store.service';
import {Entry} from '../../../entry/domain/model/entry.model';

@Injectable({ providedIn: 'root' })
export class CreateAccountUseCase {
  private readonly accountCreatorService = inject(AccountCreatorService);
  private readonly store = inject(AccountStoreService);

  execute(entries?: Entry[]): Observable<Account> {
    return this.accountCreatorService.execute(entries).pipe(
      filter((account): account is Account => !!account),
      switchMap(account =>
        combineLatest([
          this.store.saveAccounts([account]).pipe(take(1)),
          this.store.saveSelectedAccount(account).pipe(take(1)),
        ]).pipe(
          map(() => account)
        )
      )
    );
  }
}
